module.exports = __webpack_public_path__ + "static/media/IDEO.f7605858.jpg";